import enUS from './en-US.json';

export default {
  'en-US': enUS
};
